import {Injectable} from '@angular/core';
import * as gibberishAES from "../../../node_modules/gibberish-aes/dist/gibberish-aes-1.0.0";

@Injectable()
class CypherService {
    private key: string = "??c{+_4n-B;n@VJc6h Wukez!ehhEL";

    public encrypt(text: string): string {
        return gibberishAES.enc(text, this.key).replace(/\n/g, '');
    }

    public decrypt(text: string): string {
        return gibberishAES.dec(text, this.key);
    }
}

export default CypherService;






// WEBPACK FOOTER //
// ./src/app/services/cypher.service.ts